import Swiper from 'swiper';

export default function() {
  document.querySelectorAll('a').forEach((anchor) => {
    if (!anchor.href || anchor.href === '#') {
      anchor.addEventListener('click', (event) => {
        event.preventDefault();
      });
    }
  });
}
